import { message } from 'antd';

function Errormsg(errors: any) {
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const error in errors?.data) {
    message.error(errors?.data[error]);
  }
}

export default Errormsg;
